import { isEmpty } from "lodash";
/** @returns { Object<string, import('vuex').Getter> } */
export default {
	
};
